/**
 * Automatic vs manual entry for `property_list` autofill fields (e.g. a
 * förhandlingsordning's Fastighetsbeteckningar / adresser).
 *
 * Automatic (default): the value is regenerated from the linked properties
 * whenever they change. Manual: the user edits the text freely and property
 * changes leave it alone. The manual field keys live under a reserved
 * `values` key so the choice survives reloads and travels with the contract.
 */
export const PROPERTY_LIST_MANUAL_KEY = '__property_list_manual';
export function manualPropertyListKeys(values) {
    const raw = values?.[PROPERTY_LIST_MANUAL_KEY];
    return new Set(Array.isArray(raw) ? raw.filter((k) => typeof k === 'string') : []);
}
//# sourceMappingURL=property-list-mode.js.map